import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const LinkedData_Localization_Fragment = graphqlShopifyStorefront(`
  fragment LinkedData_Localization on Localization {
    country {
      availableLanguages {
        isoCode
      }
      currency {
        isoCode
      }
      isoCode
      name
    }
  }
`);

export const LinkedData_ProductVariant_Fragment = graphqlShopifyStorefront(
  `
  fragment LinkedData_ProductVariant on ProductVariant {
    availableForSale
    barcode
    currentlyNotInStock
    id
    image {
      ...Image
    }
    price {
      amount
      currencyCode
    }
    requiresShipping
    taxable
    title
    selectedOptions {
      name
      value
    }
    sku
    weight
  }
`,
  // [Image_Fragment],
);

export const LinkedData_ProductVariantsConnectionMasked_Fragment =
  graphqlShopifyStorefront(
    `
  fragment LinkedData_ProductVariantsConnectionMasked on ProductVariantConnection {
    edges {
      node {
        ...LinkedData_ProductVariant
      }
    }
  }
`,
    // [LinkedData_ProductVariant_Fragment],
  );

export const LinkedData_Product_Fragment = graphqlShopifyStorefront(
  `
  fragment LinkedData_Product on Product {
    availableForSale
    collectionsConnectionMasked: collections(first: $collectionsFirst) {
      edges {
        node {
          ...Collection
        }
      }
    }
    description
    mediaConnectionMasked: media(first: 16) {
      ...MediaConnectionMasked
    }
    handle
    id
    optionsMasked: options(first: 16) {
      ...ProductOption
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    releaseDate: metafield(namespace: "custom", key: "release_date") {
      value
    }
    productType
    tags
    title
    variantsConnectionMasked: variants(first: 64) {
      ...LinkedData_ProductVariantsConnectionMasked
    }
    vendor
  }
`,
  // [
  //   Collection_Fragment,
  //   LinkedData_ProductVariantsConnectionMasked_Fragment,
  //   MediaConnectionMasked_Fragment,
  //   ProductOption_Fragment,
  //   Video_Fragment,
  // ],
);

export const LinkedData_PaymentSettings_Fragment = graphqlShopifyStorefront(`
  fragment LinkedData_PaymentSettings on PaymentSettings {
    acceptedCardBrands  
    cardVaultUrl
    countryCode
    currencyCode
    enabledPresentmentCurrencies
    shopifyPaymentsAccountId
    supportedDigitalWallets
  }
`);

export const LinkedData_Shop_Fragment = graphqlShopifyStorefront(
  `
  fragment LinkedData_Shop on Shop {
    brand {
      logo {
        alt
        image {
          ...Image
        }
      }
    }
    name
    paymentSettings {
      ...LinkedData_PaymentSettings
    }
  }
`,
  // [
  //   Image_Fragment,
  //   MediaConnectionMasked_Fragment,
  //   LinkedData_PaymentSettings_Fragment,
  // ],
);
